import React from 'react';
import Button, { type ButtonProps } from '@mui/material/Button';
import classNames from 'classnames';

type MultiActionDialogButtonProps = ButtonProps & {
  children: React.ReactNode;
  className?: string;
  ['data-testid']?: string;
};

function MultiActionDialogButton({
  children,
  className = '',
  'data-testid': dataTestid = '',
  ...rest
}: MultiActionDialogButtonProps) {
  return (
    <Button
      className={classNames(
        className,
        'hover:bg-transparent py-0 pr-5 font-normal tracking-[.75px] text-white hover:text-white',
      )}
      sx={{
        textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      }}
      disableRipple
      disableFocusRipple
      variant="text"
      {...(dataTestid !== '' && { 'data-testid': dataTestid })}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default MultiActionDialogButton;
